import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_VENDOR_CAR_TYPES, GET_VENDOR_CAR_TYPES_SUCCESS, GET_VENDOR_CAR_TYPES_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';

function* getVendorCarTypes({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/car-type`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_CAR_TYPES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VENDOR_CAR_TYPES_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_CAR_TYPES_ERROR, payload: error });
  }
}

export function* watchGetVendorCarTypes() {
  yield takeEvery(GET_VENDOR_CAR_TYPES, getVendorCarTypes);
}

function* getVendorCarTypesSaga() {
  yield all([fork(watchGetVendorCarTypes)]);
}

export default getVendorCarTypesSaga;
